import * as dressageProtocols from './actions';
import {DressageProtocolListState, JsonDressageProtocolListItem} from './types';
import {ActionType, getType} from 'typesafe-actions';
import {Middleware} from 'redux';
import environment from "../environment";

export const fetchDressageItemsMiddleware: Middleware<{}, DressageProtocolListState> = ({getState}) => next => async (action: ActionType<typeof dressageProtocols>) => {
  next(action);

  if (action.type != getType(dressageProtocols.updateDressageProtocols)) {
    return;
  }

  next(dressageProtocols.fetchDressageProtocols.request());
  try {
    const response = await fetch(`${environment.getHost()}/api/dressageprotocols/v1`);
    const json: JsonDressageProtocolListItem[] = await response.json();
    next(dressageProtocols.fetchDressageProtocols.success(json));
  } catch (e) {
    next(dressageProtocols.fetchDressageProtocols.failure(e));
  }
};
